export default __webpack_public_path__ + "static/media/OralHistory1.fe11809d.png";